module.exports = __webpack_public_path__ + "static/img/one.277caf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/remove/one.png
// module id = qkPJ
// module chunks = 0